"use strict";
(() => {
  var g = new WeakMap();
  function S(k) {
    let h = [];
    for (let e of k.querySelectorAll("[data-pm-gif-demo]")) {
      if (g.has(e)) continue;
      let n = e.querySelector("img[data-pm-gif-url]"),
        t = e.querySelector("[data-pm-gif-toggle]"),
        o = e.querySelector("[data-pm-gif-retry]"),
        d = e.closest("[data-pm-carousel-slide]"),
        G = () => !d || d.getAttribute("data-pm-active") === "true",
        l = n?.dataset.pmGifUrl,
        u = n?.dataset.pmGifPoster;
      if (!n || !l || !u) continue;
      let m = e.ownerDocument.defaultView;
      if (!m) continue;
      let E = (v) => {
        try {
          let p = new URL(v, e.ownerDocument.baseURI);
          return (
            ["http:", "https:"].includes(p.protocol) &&
            !p.username &&
            !p.password
          );
        } catch {
          return !1;
        }
      };
      if (!E(l) || !E(u)) continue;
      let i = m.matchMedia?.("(prefers-reduced-motion: reduce)"),
        r = !1,
        a = !1,
        s = (v) => {
          ((r = v && !a && G()),
            (n.src = r ? l : u),
            t?.setAttribute("aria-pressed", String(r)),
            t &&
              (t.textContent = r
                ? "Pausar animación"
                : "Reproducir animación"));
        },
        b = () => {
          a || s(!r);
        },
        y = () => {
          a ||
            ((a = !0),
            s(!1),
            o && (o.hidden = !1),
            t &&
              ((t.disabled = !0), (t.textContent = "Animación no disponible")));
        },
        f = () => {
          s(!i?.matches);
        },
        w = () => {
          ((a = !1),
            o && (o.hidden = !0),
            t && (t.disabled = !1),
            s(!i?.matches));
        },
        M = d ? new m.MutationObserver(f) : null;
      (M?.observe(d, { attributes: !0, attributeFilter: ["data-pm-active"] }),
        o?.addEventListener("click", w),
        t?.addEventListener("click", b),
        n.addEventListener("error", y),
        i?.addEventListener?.("change", f),
        s(!i?.matches));
      let A = () => {
        (M?.disconnect(),
          o?.removeEventListener("click", w),
          t?.removeEventListener("click", b),
          n.removeEventListener("error", y),
          i?.removeEventListener?.("change", f),
          g.delete(e));
      };
      (g.set(e, A), h.push(A));
    }
    return () => {
      for (let e of h) e();
    };
  }
  var L,
    c = () => {
      (L?.(), (L = S(document)));
    };
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", c, { once: !0 })
    : c();
  document.addEventListener("shopify:section:load", c);
  document.addEventListener("shopify:section:unload", c);
  window.addEventListener("pagehide", () => L?.());
})();
